import { ref } from 'vue'

const STORAGE_KEY = 'visualGameStudio.theme'
/** 主题名 → @drama/ui theme.css 里的 data-theme 值；两套 token 都在共享主题文件里，这里只做切换与记忆。 */
const THEME_ATTRIBUTES = Object.freeze({ dark: 'vg-studio', light: 'vg-studio-light' })

/** @returns {'dark'|'light'} 上次记住的主题，没记过就是深色（宿主原来的唯一主题） */
export function readStoredTheme() {
  return globalThis.localStorage?.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'
}

/** @param {'dark'|'light'} value */
export function applyStudioTheme(value) {
  document.documentElement.dataset.theme = THEME_ATTRIBUTES[value] ?? THEME_ATTRIBUTES.dark
}

const theme = ref(readStoredTheme())

/** 创作台的深浅主题：模块级状态，顶栏切换后全站生效并写入 localStorage。 */
export function useStudioTheme() {
  /** @param {'dark'|'light'} value */
  function setTheme(value) {
    theme.value = value === 'light' ? 'light' : 'dark'
    applyStudioTheme(theme.value)
    globalThis.localStorage?.setItem(STORAGE_KEY, theme.value)
  }

  function toggle() {
    setTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  return { theme, setTheme, toggle }
}
